module.exports = __webpack_public_path__ + "static/media/Blender-6.5bf459d3.webp";